// import { spinner } from '../extension/Components.js';
import '../assets/events/EventKey.js';
import '../assets/events/keynavigator.js';
import {
  alerta,
  run_waitMe,
  InitTenantConfig,
  RetornaCertificado,
  RetornaServicio,
  ExtractCode,
} from '../assets/js/Utilidades.js';
import { setfocusable } from '../assets/js/statev.js';
import {
  clearIntegratedAccess,
  getApplicationRoute,
  getIntegratedParam,
  isIntegratedAccessEnabled,
  removeIntegratedParamFromUrl,
  setIntegratedAccess,
} from '../assets/js/integratedAccess.js';
import {
  clearRememberedIntegratedParam,
  getRememberedIntegratedParam,
  rememberIntegratedParam,
} from '../assets/js/rememberedIntegratedAccess.js';
var Nombretxt, codiempresa, username, password, cedulacliente;
var codi;
var desc;
var WSTercerosComercial = 6; //1
var WSServicios = 15;
setfocusable('');
$(async function () {
  // inciar focus en un input especifico Usuario
  $('#Usuario').focus();

  // Resolver el tenant en cada ingreso, sin heredar una API de un build anterior.
  const tenantConfig = await InitTenantConfig('#conloguin', {
    forceRefresh: true,
  });
  // InitTenantConfig muestra el error y devuelve null si no pudo resolver el tenant.
  if (!tenantConfig) return;

  // window.alert(
  //   'Configuracion del tenant:\n' +
  //     JSON.stringify(tenantConfig.configSite, null, 2),
  // );

  const certificado = String(tenantConfig.configSite?.Cerssl || '').trim();
  const servicio = String(tenantConfig.configSite?.URLServicio || '').trim();
  if (!certificado || !servicio) {
    alerta(
      'La configuracion de la empresa no tiene una URL de servicios. Recarga la pagina cuando se haya corregido.',
      'Configuracion',
      2,
      0,
      '#conloguin',
    );
    return;
  }
  const tenantServiceUrl = (certificado + servicio).replace(/\/+$/, '');

  const integratedParam = getIntegratedParam();
  const integratedAccessEnabled = isIntegratedAccessEnabled();
  const integratedContext = JSON.stringify([
    window.location.origin,
    window.location.pathname.replace(/index\.html$/i, ''),
    String(tenantConfig.configSite?.dominio || '').trim().toLowerCase(),
    tenantServiceUrl,
  ]);
  // Un enlace explicito siempre tiene prioridad, incluso si Param esta vacio.
  const loginParam =
    integratedParam !== null
      ? integratedParam
      : integratedAccessEnabled
        ? getRememberedIntegratedParam(integratedContext)
        : null;

  // Toda visita al login inicia sin restricciones heredadas de otra sesion.
  clearIntegratedAccess();

  localStorage.removeItem('DatUsuario');
  localStorage.removeItem('DatSeguridades');
  localStorage.removeItem('DatEmpresa');
  localStorage.removeItem('DatGenerales');
  localStorage.removeItem('UsuarioLoguin');
  localStorage.removeItem('EmpresaLoguin');
  localStorage.removeItem('VisiblebotonReferencia');
  localStorage.removeItem('ReferenciaWEB');
  if (integratedParam !== null) {
    removeIntegratedParamFromUrl();
  }

  if (integratedAccessEnabled && loginParam !== null) {
    await iniciarIngresoIntegrado(loginParam, tenantServiceUrl, {
      context: integratedContext,
      remembered: integratedParam === null,
    });
    return;
  }
  $('#btnEmpresaI').click(function (e) {
    if ($('#Usuario').val() != '') {
      run_waitMe('#Mmaestrosicontent').show();
      Nombretxt = 'Empresai';
      ConsultaMaestrosi($('#Usuario').val());
    }
  });
  $('#btnEmpresaIfs').click(function (e) {
    if ($('#Usuariofs').val() != '') {
      run_waitMe('#Mmaestrosicontent').show();
      Nombretxt = 'Empresaifs';
      ConsultaMaestrosi($('#Usuariofs').val());
    }
  });
  const empresaInput = document.getElementById('Empresai');
  const empresaInputfs = document.getElementById('Empresaifs');
  const form = document.getElementById('formLogin');
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!empresaInput.value.trim()) {
      empresaInput.classList.add('is-invalid');
    } else {
      empresaInput.classList.remove('is-invalid');
    }
    form.classList.add('was-validated');
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    btnIngreso();
  });
  const forms = document.getElementById('formLogins');
  forms.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!empresaInputfs.value.trim()) {
      empresaInputfs.classList.add('is-invalid');
    } else {
      empresaInputfs.classList.remove('is-invalid');
    }
    forms.classList.add('was-validated');
    if (!forms.checkValidity()) {
      forms.reportValidity();
      return;
    }
    btnenviarctsn();
  });
  document.getElementById('btnToggle').addEventListener('click', () => {
    const pass = document.getElementById('Contrasena');
    const icon = document.getElementById('iconToggle');

    // Cambia de 'password' a 'text' y viceversa
    pass.type = pass.type === 'password' ? 'text' : 'password';

    // Alterna clases del icono (bi-eye ↔ bi-eye-slash)
    icon.classList.toggle('bi-eye');
    icon.classList.toggle('bi-eye-slash');
  });
  $('#btnOlVContrasena').click(function (e) {
    $('#formLogin').hide();
    $('#formLogins').show();
    $('#titleloguin').text('Recuperar Contraseña');
    $('#desloguin').text(
      'Introduzca su nombre de usuario y correo electronico',
    );
  });
  $('#btnIniciarss').click(function (e) {
    $('#formLogin').show();
    $('#formLogins').hide();
    $('#titleloguin').text('Iniciar Sesión');
    $('#desloguin').text(
      'Introduzca su nombre de usuario y contraseña para iniciar sesión',
    );
  });
});

async function iniciarIngresoIntegrado(
  param,
  tenantServiceUrl,
  { context, remembered },
) {
  $('#formLogin, #formLogins').hide();
  run_waitMe('#bdLoguin').show();

  try {
    const url =
      tenantServiceUrl +
      '/api/Seguridad/IngresoAppUrl?Param=' +
      encodeURIComponent(param);
    const response = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });

    let data = null;
    try {
      data = await response.json();
    } catch (_) {}

    // Solo un rechazo de autenticacion invalida lo recordado. Una caida del
    // servicio, error de red o respuesta ilegible permite intentar mas tarde.
    if (
      remembered &&
      (response.status === 401 ||
        response.status === 403 ||
        (response.status < 500 && data?.Exito === false))
    ) {
      clearRememberedIntegratedParam();
    }

    if (!response.ok || !data || data.Exito !== true) {
      throw new Error(
        data?.Mensaje || 'No fue posible iniciar la sesion integrada.',
      );
    }

    const idAplicacion = String(data.IdAplicacion || '');
    const route = getApplicationRoute(idAplicacion);
    const seguridades = Array.isArray(data.Seguridades)
      ? data.Seguridades
      : [];
    const usuario = seguridades[0];
    const empresa = data.DatosEmpresa;

    if (
      typeof route !== 'string' ||
      !usuario ||
      typeof usuario !== 'object' ||
      Array.isArray(usuario) ||
      !Object.keys(usuario).length ||
      !empresa ||
      typeof empresa !== 'object' ||
      Array.isArray(empresa) ||
      !Object.keys(empresa).length
    ) {
      throw new Error('La respuesta del acceso integrado esta incompleta.');
    }

    localStorage.setItem('DatEmpresa', JSON.stringify(empresa));
    localStorage.setItem('DatSeguridades', JSON.stringify(seguridades));
    localStorage.setItem('DatUsuario', JSON.stringify(usuario));
    const usuarioLoguin =
      String(usuario.Nombre || '').trim() ||
      String(data.DatosDesencriptados?.Usuario || '').trim() ||
      String(usuario.Codigo || '').trim();
    localStorage.setItem('UsuarioLoguin', usuarioLoguin);
    localStorage.setItem(
      'EmpresaLoguin',
      `${empresa.NomEmpresa || ''}[${empresa.Codigo || ''}]`,
    );
    localStorage.setItem('TieneMenu', '0');
    localStorage.setItem('VisiblebotonReferencia', '0');
    setIntegratedAccess(idAplicacion);
    rememberIntegratedParam(param, context);

    window.location.replace(route);
  } catch (error) {
    clearIntegratedAccess();
    localStorage.removeItem('DatUsuario');
    localStorage.removeItem('DatSeguridades');
    localStorage.removeItem('DatEmpresa');

    try {
      sessionStorage.setItem(
        '__SOFTOOLS_ERROR__',
        JSON.stringify({
          title: 'No fue posible ingresar a FC360',
          desc:
            error?.message ||
            'El enlace de acceso es invalido o no tiene permisos.',
        }),
      );
    } catch (_) {}

    window.location.replace('Error/Error.html');
  }
}

function GenerarContrasena(Opcion, CodEmpresa, loguinUsuario, emailUsuario) {
  $.getJSON(
    RetornaCertificado() + RetornaServicio() + '/api/Utilidad/RandomString?',
    { length: 6 },
    function (data) {
      let Rcodigo = data;
      RecuperarContrasena(
        Opcion,
        CodEmpresa,
        loguinUsuario,
        Rcodigo,
        emailUsuario,
      );
    },
  ).fail(function (jqXHR, textStatus, errorThrown) {
    run_waitMe('#bdLoguin').hide(true);
    alert('error: ' + textStatus + ' ' + errorThrown);
  });
}
function RecuperarContrasena(
  Opcion,
  CodEmpresa,
  loguinUsuario,
  Rcodigo,
  emailUsuario,
) {
  let empresa = $('#Empresai').val();
  let splitempresa = empresa.split('[');
  let nomempresa = splitempresa[0];
  $.getJSON(
    RetornaCertificado() +
      RetornaServicio() +
      '/api/Seguridad/ConsultaDatosUsuario',
    {
      pOpcion: Opcion,
      pEmpresa: CodEmpresa,
      pCodigo: loguinUsuario,
      pParametro1: Rcodigo,
      pParametro2: emailUsuario,
    },
    function (data) {
      if (data[0].ctrlretorno == 2) {
        mensaje =
          'Hola! ' +
          loguinUsuario +
          ', ' +
          nomempresa +
          ' te informa que debes ingresar la siguiente contraseña : ' +
          Rcodigo +
          ' para iniciar sesión. Recuerda que por tu seguridad debes cambiarla cuando  ingrese a la plataforma.';
        EnviarCorreo(emailUsuario, mensaje, CodEmpresa, data[0].mensaje);
        $('#btnIniciarss').click();
      } else {
        run_waitMe('#bdLoguin').hide(true);
        // alerta(data[0].mensaje, "Solo Creditos", 2);
        alerta(data[0].mensaje, 'Solo Creditos', 2, '', '#conloguin');
      }
    },
  ).fail(function (jqXHR, textStatus, errorThrown) {
    alerta('error: ' + textStatus + ' ' + errorThrown, 'Solo Creditos', 1, 1);
    run_waitMe('#bdLoguin').hide(true);
  });
}
function EnviarCorreo(emailcliente, mensaje, codempresa, mensajenotificacion) {
  $.getJSON(
    RetornaCertificado() + RetornaServicio() + '/api/Utilidad/SendMail',
    {
      parametros: 'Reporte#|ParamReport#|Adjunto#0',
      Mail: emailcliente,
      Mensaje: mensaje,
      pEmpresa: codempresa,
      urldocumento: '',
    },
    function (data) {
      if (data == '') {
        alerta(mensajenotificacion, 'Solo Creditos', 2, 1);
      } else {
        alerta(
          'Hola! Tuvimos problemas al momento de enviar el correo ponte en contacto con el administrador de la plataforma. ',
          'Solo Creditos',
          2,
          1,
        );
      }
      run_waitMe('#bdLoguin').hide(true);
    },
  ).fail(function (jqXHR, textStatus, errorThrown) {
    run_waitMe('#bdLoguin').hide(true);
    alert('error: ' + textStatus + ' ' + errorThrown);
  });
}
window.btnenviarctsn = function btnenviarctsn() {
  run_waitMe('#bdLoguin').show();
  let loguinUsuario = $('#Usuariofs').val();
  let emailUsuario = $('#EmailUsuario').val();
  let CodEmpresa = ExtractCode($('#Empresaifs').val());
  GenerarContrasena(
    'RestablecerContrasena',
    CodEmpresa,
    loguinUsuario,
    emailUsuario,
  );
};
window.btnIngreso = function btnIngreso() {
  window.Login = true;
  run_waitMe('#bdLoguin').show();
  ConsultaMaestrosLoguin(ExtractCode($('#Empresai').val()));
};
function ConsultaMaestrosi(Opcion) {
  $.getJSON(
    RetornaCertificado() +
      RetornaServicio() +
      '/api/Seguridad/ConsultaEmpresas',
    { pUsername: Opcion },
    function (data) {
      $('#tblmaestrosi').find('tr:gt(0)').remove();
      codi = '';
      desc = '';
      for (var i = 0; i < data.length; i++) {
        drawRowMaestrosi(data[i]);
      }
      $('table#tblmaestrosi > tbody tr').keynavigator({
        activeClass: 'selected',
        keys: {
          enter: function ($el) {
            $el.click();
            $('#btnAceptari').focus();
          },
        },
      });
      var count = $('#tblmaestrosi tr').length;
      if (count > 1) {
        $('#tblmaestrosi tbody tr')[0].click();
      }
      // $('#tblmaestrosi').waitMe('hide');
      run_waitMe('#Mmaestrosicontent').hide(true);
    },
  ).fail(function (jqXHR, textStatus, errorThrown) {
    alerta('error: ' + textStatus + ' ' + errorThrown, 'Solo Creditos', 1);
    // $('#tblmaestrosi').waitMe('hide');
    run_waitMe('#Mmaestrosicontent').hide(true);
  });
}
function ConsultaMaestrosLoguin(codiempresa) {
  $.getJSON(
    RetornaCertificado() +
      RetornaServicio() +
      '/api/Seguridad/ConsultaEmpresaLoguin',
    { pCodEmpresa: codiempresa },
    function (data) {
      if (data.Mensaje == '') {
        localStorage.setItem('DatEmpresa', JSON.stringify(data));
        if (
          codiempresa != '' &&
          username != '' &&
          password != '' &&
          cedulacliente != '' &&
          codiempresa != null &&
          username != null &&
          password != null &&
          cedulacliente != null
        ) {
          IngresoApp(codiempresa, username, password, WSTercerosComercial);
        } else {
          if ($('#lblIden').text() == 'Servicio') {
            IngresoApp(
              codiempresa,
              $('#Usuario').val(),
              $('#Contrasena').val(),
              WSServicios,
            );
          } else {
            IngresoApp(
              codiempresa,
              $('#Usuario').val(),
              $('#Contrasena').val(),
              WSTercerosComercial,
            );
          }
        }
      } else {
        run_waitMe('#bdLoguin').hide(true);
        alerta(data.Mensaje, 'Solo Creditos', 2, 1);
      }
    },
  ).fail(function (jqXHR, textStatus, errorThrown) {
    alerta('error: ' + textStatus + ' ' + errorThrown, 'Solo Creditos', 1, 1);
    run_waitMe('#bdLoguin').hide(true);
  });
}
function IngresoApp(codiempresa, username, password, IdAplicacion) {
  $.getJSON(
    RetornaCertificado() + RetornaServicio() + '/api/Seguridad/IngresoApp',
    {
      pCodEmpresa: codiempresa,
      pUsername: username,
      pPassword: password,
      pIdAplicacion: IdAplicacion,
    },
    function (data) {
      if (data[0].Mensaje == '') {
        localStorage.setItem('DatSeguridades', JSON.stringify(data));
        run_waitMe('#bdLoguin').hide(true);
        if (
          $('#Usuario').val() != '' &&
          $('#Empresai').val() != '' &&
          $('#Usuario').val() != null &&
          $('#Empresai').val() != null
        ) {
          localStorage.setItem('UsuarioLoguin', $('#Usuario').val());
          localStorage.setItem('EmpresaLoguin', $('#Empresai').val());
        }
        if ($('#lblIden').text() == 'Servicio') {
          localStorage.setItem('VisiblebotonReferencia', '0');
          localStorage.setItem('DatUsuario', JSON.stringify(data[0]));
          window.open(
            './SoloCreditos/Referencias.html',
            '_self',
            'toolbar=yes,scrollbars=yes,resizable=no',
          );
        } else {
          if (data.length == 2) {
            localStorage.setItem('TieneMenu', '0');
            for (var i = 0; i < data.length; i++) {
              if (data[i].IdAplicacion != '6') {
                localStorage.setItem('DatUsuario', JSON.stringify(data[i]));
              }
            }
            if (JSON.parse(localStorage.getItem('DatUsuario')).VIAapp == '0') {
              localStorage.setItem('DatSeguridades', '');
              localStorage.setItem('DatUsuario', '');
              alerta(
                'Solo Creditos esta bloqueada por favor comuniquese con su administrador',
                'Solo Creditos',
                1,
                1,
              );
            } else {
              switch (
                JSON.parse(localStorage.getItem('DatUsuario')).IdAplicacion
              ) {
                case '1':
                  window.location.href = 'SoloCreditos/sidebars.html';
                  break;
                case '3':
                  window.location.href = 'Financiero/sidebarf.html';
                  break;
                case '4':
                  window.location.href =
                    'Gerencial/PanelPrincipalGerencial.html';
                  break;
                case '11':
                  window.location.href = 'POS/PanelPrincipalPOS.html';
                  break;
                case '16':
                  localStorage.setItem('CedulaRegistro', cedulacliente);
                  window.location.href = 'ServiciosWEB/MenuServicios.html';
                  break;
                case '7':
                  window.location.href =
                    'Correspondencia/sidebarcorrespondencia.html';
                  break;
                case '12':
                  window.location.href = 'Especiales/sidebare.html';
                  break;
                default:
              }
            }
          } else {
            localStorage.setItem('TieneMenu', '1');
            localStorage.setItem('VisiblebotonReferencia', '1');
            const match = data.find(
              (item) => item.IdAplicacion === '1' || item.IdAplicacion === '3',
            );
            if (match) {
              localStorage.setItem('DatUsuario', JSON.stringify(match));
              window.location.href =
                match.IdAplicacion === '1'
                  ? 'SoloCreditos/sidebars.html'
                  : 'Financiero/sidebarf.html';
            }
          }
        }
      } else {
        run_waitMe('#bdLoguin').hide(true);
        if (data[0].Codigo != '') {
          $('#Contrasena').val('');
          localStorage.setItem('DatUsuario', JSON.stringify(data[0]));
          popUpObj = window.open(
            'CContrasena.html',
            'ModalPopUp',
            'toolbar=no,' +
              'scrollbars=no,' +
              'location=no,' +
              'statusbar=no,' +
              'menubar=no,' +
              'resizable=0,' +
              'width=450,' +
              'height=300,' +
              'left = 450,' +
              'directories=no,' +
              'status=no,' +
              'titlebar=no,' +
              'top=100',
          );
          popUpObj.focus();
          alerta(data[0].Mensaje, 'Solo Creditos', 2, 1);
        } else {
          alerta(data[0].Mensaje, 'Solo Creditos', 2, '', '#conloguin');
          setfocusable('Contrasena');
        }
      }
    },
  ).fail(function (jqXHR, textStatus, errorThrown) {
    alerta('error: ' + textStatus + ' ' + errorThrown, 'Solo Creditos', 1, 1);
    //   run_waitMe('#bdLoguin').hide(true);
    run_waitMe('#bdLoguin').hide(true);
  });
}
function drawRowMaestrosi(rowData) {
  var row = $('<tr />');
  $('#tblmaestrosi tbody').append(row); //this will append tr element to table... keep its reference for a while since we will add cels into it
  row.append($('<td>' + rowData.NomEmpresa + '</td>'));
  row.append($('<td>' + rowData.Codigo + '</td>'));
  row.append($('<td>' + rowData.Login + '</td>'));
}
$('#Mmaestrosi').on('hidden.bs.modal', function () {
  $('#tblmaestrosi').find('tr:gt(0)').remove();
});
$('#Mmaestrosi').on('shown.bs.modal', function () {
  var count = $('#tblmaestrosi tr').length;
  if (count > 1) {
    $('#tblmaestrosi tbody tr')[0].click();
  }
});
$('#tblmaestrosi').on('dblclick', 'tbody tr', function (event) {
  var $row = $(this).closest('tr');
  var $tds = $row.find('td');
  var con = 0;
  codi;
  desc;
  $.each($tds, function () {
    con = con + 1;
    if (con == 2) {
      codi = $(this).text();
    } else if (con == 1) {
      desc = $(this).text();
    }
  });
  $('#' + Nombretxt).val(desc + '[' + codi + ']');
  $('#Mmaestrosi').modal('toggle');
  $('#' + Nombretxt).removeClass('is-invalid');
});
$('#tblmaestrosi').on('click', 'tbody tr', function (event) {
  $(this).addClass('selected').siblings().removeClass('selected');
  var $row = $(this).closest('tr');
  var $tds = $row.find('td');
  var con = 0;
  codi;
  desc;
  $.each($tds, function () {
    con = con + 1;
    if (con == 2) {
      codi = $(this).text();
    } else if (con == 1) {
      desc = $(this).text();
    }
  });
});
$('#btnAceptari').click(function (e) {
  $('#' + Nombretxt).val(desc + '[' + codi + ']');
  $('#' + Nombretxt).removeClass('is-invalid');
});
function ConsultaMaestrosLoguinEmpresa(codiempresa, nombreEmpresa) {
  $.getJSON(
    RetornaCertificado() +
      RetornaServicio() +
      '/api/Seguridad/ConsultaEmpresaLoguin',
    { pCodEmpresa: codiempresa },
    function (data) {
      if (data.Mensaje == '') {
      } else {
        run_waitMe('#bdLoguin').hide(true);
        alerta(data.Mensaje, 'Solo Creditos', 2, 1);
      }
    },
  ).fail(function (jqXHR, textStatus, errorThrown) {
    alerta('error: ' + textStatus + ' ' + errorThrown, 'Solo Creditos', 1, 1);
    run_waitMe('#bdLoguin').hide(true);
  });
}
